import { apiClientWithMiddleware } from '../utils/API';
const irisAppDataEndpoint = '/iris-read/v1/app';
export const getIsPaidPortal = portalId => apiClientWithMiddleware().get(irisAppDataEndpoint, {
  query: {
    portalId,
    hubField: 'paidHub'
  }
}).then(({
  hub: {
    paidHub
  }
}) => paidHub);